import { dimensions, SvgIconProps } from "./SvgIcon";

export const GroupByIcon = (props: SvgIconProps) => {
  const { width, height } = dimensions(props);
  return (
    <svg
      style={{ display: "block", ...props.style }}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4819 4.14844C10.4889 4.26544 10.4999 4.38044 10.4999 4.49844C10.4983 6.08925 9.86566 7.61445 8.74079 8.73932C7.61591 9.8642 6.09071 10.4968 4.4999 10.4984C4.3819 10.4984 4.2669 10.4874 4.1499 10.4804C4.55537 10.9395 5.05055 11.3107 5.60492 11.5711C6.1593 11.8315 6.76114 11.9756 7.37334 11.9946C7.98554 12.0136 8.59514 11.907 9.16457 11.6814C9.734 11.4558 10.2512 11.1159 10.6843 10.6828C11.1174 10.2497 11.4572 9.73254 11.6828 9.16311C11.9084 8.59367 12.015 7.98407 11.9961 7.37187C11.9771 6.75967 11.833 6.15784 11.5726 5.60346C11.3122 5.04908 10.941 4.5539 10.4819 4.14844Z"
        fill="currentColor"
      />
      <path
        d="M4.5 9C6.98528 9 9 6.98528 9 4.5C9 2.01472 6.98528 0 4.5 0C2.01472 0 0 2.01472 0 4.5C0 6.98528 2.01472 9 4.5 9Z"
        fill="currentColor"
      />
    </svg>
  );
};
